module.exports = __webpack_public_path__ + "assets/img/docs3.bc7474e1.svg";